import { EntityType } from './EntityType';
import { LayoutType } from './Layout';

export enum ComponentSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export type ComponentType = EntityType | LayoutType;

export const AvailableComponentSizes: PartialRecord<ComponentType, ComponentSize[]> = {
  [EntityType.CALL_TO_ACTION]: [ComponentSize.SMALL, ComponentSize.MEDIUM, ComponentSize.LARGE],
  [LayoutType.SPACER]: [ComponentSize.SMALL, ComponentSize.MEDIUM, ComponentSize.LARGE],
};
